import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { detectLocale } from "./i18n/detect";
import { LOCALE_PREFIX, stripLocalePrefix } from "./i18n/config";

export const getRouter = () => {
  const queryClient = new QueryClient();

  // Resolved identically on server and client (URL prefix -> cookie ->
  // Accept-Language / navigator), so SSR and hydration always agree.
  const locale = detectLocale();
  const prefix = LOCALE_PREFIX[locale];

  const router = createRouter({
    routeTree,
    context: { queryClient, locale },
    // Locale prefixes are handled by bidirectional URL rewriting: routes are
    // matched against the un-prefixed path, while every generated href keeps
    // the active locale prefix. English stays completely unprefixed.
    rewrite: {
      input: ({ url }) => {
        const next = new URL(url);
        next.pathname = stripLocalePrefix(next.pathname);
        return next;
      },
      output: ({ url }) => {
        if (!prefix) return url;
        const next = new URL(url);
        const base = stripLocalePrefix(next.pathname);
        next.pathname = base === "/" ? prefix : `${prefix}${base}`;
        return next;
      },
    },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
  });

  return router;
};
